import proctor1Img from '../../imgs/proctor1.webp';
import proctor2Img from '../../imgs/proctor2.webp';
import proctorBadImg from '../../imgs/proctor_bad.webp';

const QUIZ_COPY = {
    ru: {
        title: 'Проверка готовности к прокторингу',
        progress: 'Шаг {current} из {total}',
        completeTitle: 'Всё готово',
        completeText: 'Инструкции подтверждены. Теперь можно переходить к запуску экзамена.',
        unlockHint: 'Сначала пройдите короткую проверку готовности к прокторингу.',
        questions: [
            {
                prompt: 'Ноутбук подключён к зарядке?',
                answer: 'Да, проработает 3 часа без проблем',
            },
            {
                prompt: 'Смартфон полностью заряжен или подключён к зарядке?',
                answer: 'Да, 3 часа стриминга видео спокойно',
            },
            {
                prompt: 'Камера должна быть отрегулирована так, чтобы всегда было видно лицо, как на примере ниже. Когда вы решаете, ваше лицо не должно покидать кадр.',
                answer: 'Хорошо, настрою камеру пониже',
                images: [
                    {
                        src: proctor1Img,
                        alt: 'Корректное положение лица в кадре',
                        className: 'block mx-auto w-[600px] max-w-full rounded-lg border border-gray-200',
                    },
                ],
            },
            {
                prompt: 'Камера смартфона должна быть установлена так, чтобы было видно всё ваше рабочее место: стол и бумагу, ноутбук или клавиатуру с экраном, вашу голову и руки целиком.',
                answer: 'Да, придётся поставить смартфон подальше',
                images: [
                    {
                        src: proctor2Img,
                        alt: 'Рабочее место должно попадать в кадр целиком',
                        className: 'block mx-auto w-[600px] max-w-full rounded-lg border border-gray-200',
                    },
                ],
            },
            {
                prompt: 'Использовать наушники или гарнитуру во время экзамена запрещено.',
                answer: 'Хорошо, уберу подальше',
            },
            {
                prompt: 'В случае вопроса по задаче пишите в чат под задачей, через кнопку с символом вопроса.',
                answer: 'Ок, удобно',
            },
            {
                prompt: 'В случае технических проблем пишите через телеграм-бота t.me/techleadersbot.',
                answer: 'Ок, надеюсь, не пригодится',
            },
        ],
    },
    en: {
        title: 'Proctoring readiness check',
        progress: 'Step {current} of {total}',
        completeTitle: 'Ready',
        completeText: 'You have confirmed the instructions. You can now start the exam.',
        unlockHint: 'Complete the short proctoring readiness check first.',
        questions: [
            {
                prompt: 'Is your laptop plugged in?',
                answer: 'Yes, it will last 3 hours without problems',
            },
            {
                prompt: 'Is your smartphone fully charged or plugged in?',
                answer: 'Yes, it can stream video for 3 hours',
            },
            {
                prompt: 'Adjust the camera so your face is always visible, as shown below. While solving tasks, your face must stay in the frame.',
                answer: 'Okay, I will lower the camera a bit',
                images: [
                    {
                        src: proctor1Img,
                        alt: 'Correct face position in frame',
                        className: 'block mx-auto w-[600px] max-w-full rounded-lg border border-gray-200',
                    },
                ],
            },
            {
                prompt: 'Place the smartphone camera so it shows your whole workspace: desk and paper, your laptop or keyboard and screen, and your head and hands fully.',
                answer: 'Yes, I will place the smartphone farther away',
                images: [
                    {
                        src: proctor2Img,
                        alt: 'The whole workspace must be visible',
                        className: 'block mx-auto w-[600px] max-w-full rounded-lg border border-gray-200',
                    },
                ],
            },
            {
                prompt: 'Headphones or any headset are not allowed during the exam.',
                answer: 'Okay, I will put them away',
            },
            {
                prompt: 'If you have a question about a task, use the chat under the task via the question mark button.',
                answer: 'Okay, that is convenient',
            },
            {
                prompt: 'If you have technical problems, contact t.me/techleadersbot.',
                answer: 'Okay, hopefully I will not need it',
            },
        ],
    },
};

function setStartButtonLocked(button, locked, unlockHint) {
    if (!button) {
        return;
    }
    button.disabled = locked;
    button.classList.toggle('opacity-50', locked);
    button.classList.toggle('cursor-not-allowed', locked);
    if (locked) {
        button.setAttribute('title', unlockHint);
    } else {
        button.removeAttribute('title');
    }
}

function renderImages(images = []) {
    if (!images.length) {
        return '';
    }
    return `
        <div class="mt-4 space-y-4">
            ${images.map((image) => `
                <img src="${image.src}" alt="${image.alt}" class="${image.className}">
            `).join('')}
        </div>
    `;
}

function renderQuestion(copy, question, currentIndex) {
    const total = copy.questions.length;
    return `
        <div class="rounded-2xl border border-[#C1111E]/20 bg-[#FFF8F8] p-5 md:p-6">
            <div class="mb-4 flex items-center justify-between gap-4">
                <h4 class="text-lg font-semibold text-[#C1111E]">${copy.title}</h4>
                <span class="text-sm font-medium text-gray-500">${copy.progress
                    .replace('{current}', String(currentIndex + 1))
                    .replace('{total}', String(total))}</span>
            </div>
            <div class="mb-4 h-2 overflow-hidden rounded-full bg-white">
                <div class="h-full rounded-full bg-[#C1111E] transition-all duration-300" style="width: ${((currentIndex + 1) / total) * 100}%"></div>
            </div>
            <p class="text-lg text-gray-800 leading-relaxed">${question.prompt}</p>
            ${renderImages(question.images)}
            <div class="mt-6 flex justify-center">
                <button type="button" data-role="quiz-answer"
                        class="inline-flex min-h-12 items-center justify-center rounded-md bg-[#C1111E] px-5 py-3 text-center text-base font-semibold text-white shadow transition hover:bg-[#770101]">
                    ${question.answer}
                </button>
            </div>
        </div>
    `;
}

function renderComplete(copy) {
    return `
        <div class="rounded-2xl border border-green-200 bg-green-50 p-5 md:p-6">
            <h4 class="text-lg font-semibold text-green-800">${copy.completeTitle}</h4>
            <p class="mt-2 text-base text-green-700">${copy.completeText}</p>
        </div>
    `;
}

export function initProctoringReadinessQuiz({
    container,
    startButton,
    isEnabled,
    lang,
} = {}) {
    if (!container || !startButton) {
        return {
            isCompleted: () => true,
        };
    }

    if (!isEnabled) {
        container.classList.add('hidden');
        container.innerHTML = '';
        setStartButtonLocked(startButton, false);
        return {
            isCompleted: () => true,
        };
    }

    const copy = QUIZ_COPY[(lang || 'en').toLowerCase().startsWith('ru') ? 'ru' : 'en'];
    let currentIndex = 0;
    let completed = false;

    function render() {
        if (completed) {
            container.innerHTML = renderComplete(copy);
            setStartButtonLocked(startButton, false, copy.unlockHint);
            return;
        }
        container.innerHTML = renderQuestion(copy, copy.questions[currentIndex], currentIndex);
        const answerButton = container.querySelector('[data-role="quiz-answer"]');
        if (answerButton) {
            answerButton.addEventListener('click', () => {
                if (currentIndex >= copy.questions.length - 1) {
                    completed = true;
                } else {
                    currentIndex += 1;
                }
                render();
            });
        }
    }

    container.classList.remove('hidden');
    setStartButtonLocked(startButton, true, copy.unlockHint);
    render();

    return {
        isCompleted: () => completed,
    };
}
